import {Controller} from "../controller";

declare global {
    interface Window {
        refreshSlot: (id: string, addService: boolean) => Promise<void>;
        device: string;
    }
}

export class GaleriaController extends Controller {

    /* INSTANCE */
    private static instances: any = [];
    private slideWrapper: HTMLElement;
    private prevButton: HTMLElement;
    private nextButton: HTMLElement;
    private currentIndex: number;
    private images: NodeListOf<HTMLImageElement>;
    private ads: number[];
    private contAd: number;
    private translateX: number;
    private unit: string;
    private index: number;
    private margin: number;
    private elemPerPage: number;
    private hasLazy: boolean;
    private hasAds: boolean;

    public static override async build(): Promise<void> {
        const items = document.getElementsByClassName("swiper");
        if (items.length > 0) {
            for (let item of Array.from(items)) {
                const config = this.getTranslateValue(item as HTMLElement);
                this.instances.push(new GaleriaController(item as HTMLElement, config.value, config.index, config.unit, config.margin, config.elems, config.lazy, config.ads));
            }
        }
    }

    constructor(item: HTMLElement, valueX: number, index: number, unit: string, margin: number, el: number, lazy: boolean, ads: boolean) {
        super();
        this.currentIndex = 0;
        this.contAd = 0;
        this.index = index;
        this.translateX = valueX;
        this.unit = unit;
        this.elemPerPage = el;
        this.margin = margin;
        this.images = item.querySelectorAll('[class="swiper-lazy"]') as NodeListOf<HTMLImageElement>;
        this.ads = [];
        this.hasLazy = lazy;
        this.hasAds = ads;
        this.slideWrapper = item.querySelector('[class*="swiper-wrapper"]') as HTMLElement;
        this.prevButton = item.querySelector('[class*="swiper-button-prev"]') as HTMLElement;
        this.nextButton = item.querySelector('[class*="swiper-button-next"]') as HTMLElement;
        this.prevButton.addEventListener('click', this.previous.bind(this));
        this.nextButton.addEventListener('click', this.next.bind(this));
        if (this.hasLazy) this.lazy();
        if (this.hasAds) this.adsPosition();
    }

    private static getTranslateValue(item: HTMLElement): any {
        const type = item.className;
        if (type.includes("carrusel-galeria")) {
            return {value: 100, index: item.firstElementChild?.children.length, unit: "%", margin: 0, elems: 1, lazy: true, ads: true};
        } else
        if (type.includes("lo-ultimo-carrusel")) {
            const config = this.calcWidthElement(item);
            return {value: config.width, index: config.index, unit: "px", margin: (window.device==="mv"?16:20), elems: config.elems, lazy: false, ads: false};
        } else {
            return {value: 0, index: 0, unit: "", margin: 0, elems: 0, lazy: false, ads: false};
        }
    }

    private static calcWidthElement(container: HTMLElement) : any {
        const elementoAncho = container.getElementsByTagName("article").item(0)?.offsetWidth as number;
        const totalElementos = container.querySelectorAll(".swiper-slide").length;
        const elementosEnContenedor = Math.floor(container.offsetWidth / elementoAncho);
        const pages = Math.ceil(totalElementos / elementosEnContenedor);
        return {width: Math.floor(elementoAncho), index: pages, elems: elementosEnContenedor};
    }

    private async adsPosition(): Promise<void> {
        for (let i = 0; i < this.slideWrapper.children.length; i++) {
            if (this.slideWrapper.children[i].getElementsByClassName("publicidad")[0]) {
                this.ads.push(i);
            }
        }
    }

    private async previous(): Promise<void> {
        if (this.currentIndex > 0) this.goToSlide(this.currentIndex - 1, "prev");
    }

    private async next(): Promise<void> {
        if (this.currentIndex < (this.elemPerPage===1?this.index-1:this.index)) this.goToSlide(this.currentIndex + 1, "next");
    }

    private async goToSlide(index: number, dir: string): Promise<void> {
        this.currentIndex = index;
        let translateX = (-this.currentIndex * this.translateX) + (this.margin * -(this.elemPerPage===1?this.currentIndex:this.elemPerPage)); //elementos por pagina (cuando hay varios elementos), o numero de iteracion si solo hay un elemento por pagina
        if (dir === "prev" && this.currentIndex === 0) translateX = this.margin;
        if (dir === "next" && this.currentIndex === this.index && this.elemPerPage > 1) translateX -= this.margin;
        this.slideWrapper.style.transform = `translateX(${translateX}${this.unit})`;
        if (!this.ads.includes(index)) {
            if (this.hasLazy) this.lazy();
        } else {
            if (this.hasAds) {
                (dir === "next")?this.contAd++:this.contAd--;
                const slot = this.slideWrapper.querySelector('[id="div-g1"]') as HTMLElement;
                const parent = slot.parentElement as HTMLElement;
                parent.innerHTML = "";
                this.slideWrapper.children[index].querySelector('[class="publicidad"]')?.appendChild(slot);
                window.refreshSlot('div-g1', true);
            }
        }
    }

    private async lazy(): Promise<void> {
        const index = this.contAd > 0? this.currentIndex-this.contAd : this.currentIndex;
        const imageUrl = this.images[index].getAttribute("data-src");
        this.images[index].src = imageUrl as string;
    }

}
